var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Transition', {
    attrs: {
      "name": "modal"
    }
  }, [_vm.show ? _c('section', {
    staticClass: "disclosure-modal"
  }, [_c('div', {
    staticClass: "section--container h-full sm-md:!pt-8 !pb-0"
  }, [_c('div', {
    staticClass: "container max-w-3xl section--content h-full flex flex-col"
  }, [!_vm.viewOnly ? _c('div', {
    staticClass: "shrink-0 pb-5 flex justify-between"
  }, [_c('img', {
    staticClass: "cursor-pointer",
    attrs: {
      "src": require("assets/images/back-arrow.svg"),
      "width": "20px",
      "height": "14px"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close', _vm.disclosure);
      }
    }
  }), _vm._v(" "), _vm._t("controls")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grow-1 pb-16 overflow-y-scroll overscroll-contain"
  }, [_c('div', {
    directives: [{
      name: "sani-html",
      rawName: "v-sani-html",
      value: _vm.html,
      expression: "html"
    }]
  }), _vm._v(" "), _vm._t("content")], 2)])])]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };